<woa-modal-page-layout [title]="title()" [subtitle]="'woa.heading.rsa-block.subtitle'" [contentText]="content()"
                       [translationParams]="{'tableNumber': this.orderingContextModel.currentTableNumberLabel()}">
    <woa-icon class="rsa-indicator" [name]="'no-alcohol'"></woa-icon>
    <woa-button woa-page-footer-control
                [prominence]="ButtonProminence.LOW"
                [label]="'woa.button.common.cancel'"
                (onActivate)="dismiss()"></woa-button>
    <woa-button woa-page-footer-control
                [label]="okButtonLabel()"
                (onActivate)="dismiss(true)"></woa-button>
</woa-modal-page-layout>
